import React, { Component } from 'react';
import { FiX, FiFileText } from 'react-icons/fi';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import _map from 'lodash/map';
import _uniq from 'lodash/uniq';

import api from '../services/api';
import '../scss/main.scss';
import logoSetparLight from '../images/setpar-light.svg';
import Printer from './Printer';
import {
  ThumbList,
  WrapperCanva,
  NoCoverMessage,
  WrapperAction,
  Canva,
} from './styles';
import Login from './Login';

export default class App extends Component {
  state = {
    search: '',
    coverSelected: null,
    covers: [],
    originalCovers: [],
    tags: [],
    tagSelected: null,
    isLogged: false
  };

  async componentDidMount() {
    let { data: covers } = await api.get('/data/capas.json');

    covers = covers.map(item => ({ ...item, visible: true }));

    const tags = _uniq(_map(covers, 'tag'));

    this.setState({
      covers,
      originalCovers: covers,
      tags,
    });

    const session = window.localStorage.getItem('comunicado_session')
    console.log('session', Number(session), new Date().getTime())
    if(session && Number(session) > new Date().getTime()){
      this.setState({
        isLogged: true
      })
    }else{
      window.localStorage.removeItem('comunicado_session')
    }
  }

  componentDidUpdate(_, prevState) {
    if (!prevState.coverSelected && this.state.coverSelected) {
      new Quill('#editor', {
        modules: {
          toolbar: [['bold', 'italic', 'underline']],
        },
        toolbar: '#toolbar',
        placeholder: 'Escreva a mensagem aqui...',
        theme: 'snow',
      });
    }
    if (
      (!prevState.coverSelected &&
        this.state.coverSelected &&
        this.state.coverSelected.haveHeader) ||
      (prevState.coverSelected &&
        prevState.coverSelected.image !== this.state.coverSelected.image &&
        this.state.coverSelected.haveHeader)
    ) {
      new Quill('#header-editor', {
        modules: {
          toolbar: false,
        },
        placeholder: 'Escreva um cabeçalho aqui...',
        theme: 'snow',
      });
    }
  }

  enableCustomHeightTextArea = () => {
    var tx = document.getElementsByTagName('textarea');
    for (var i = 0; i < tx.length; i++) {
      tx[i].setAttribute(
        'style',
        'height:' + tx[i].scrollHeight + 'px;overflow-y:hidden;'
      );
      tx[i].addEventListener('input', OnInput, false);
      tx[i].addEventListener('focus', OnInput, false);
    }

    function OnInput() {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    }
  };

  onFilterTag = tag => {
    this.handleSearch(this.state.search, tag);
  };

  handleSearch = (event = {}, tag = null) => {
    let { originalCovers, tagSelected, search } = this.state;
    search = event.target ? event.target.value : search;
    let covers = originalCovers;
    tagSelected = tag || tagSelected;

    if (search !== '') {
      let searchNormalized = search
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();

      searchNormalized = new RegExp(searchNormalized, 'g');

      covers = covers.map(item => {
        const legendNormalized = item.legend
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase();

        return {
          ...item,
          visible: !!legendNormalized.match(searchNormalized),
        };
      });
    }

    if (tagSelected) {
      covers = covers.filter(item => tagSelected === item.tag);
    }

    this.setState({
      search,
      covers,
      tagSelected,
    });
  };

  clearSearch = () => {
    const { originalCovers: covers } = this.state;
    this.setState({
      search: '',
      covers,
    });
  };

  selectCover = coverSelected => {
    this.setState({
      coverSelected,
    });
  };

  setIsLogged = (isLogged) => this.setState({ isLogged })

  render() {
    const { search, coverSelected, covers, tags, tagSelected, isLogged } = this.state;

    if(!isLogged) return <Login onSuccess={() => this.setIsLogged(true)} />
    
    return (
      <Printer>
        {({ isSaving, saveImage }) => (
          <>
            <nav className="navbar navbar-dark">
              <span className="navbar-brand">
                <img src={logoSetparLight} height="30" alt="Setpar" />{' '}
                Comunicados
              </span>
            </nav>
            <div className="container-fluid hc-100">
              <div className="row h-100">
                <ThumbList>
                  <aside>
                    <header className="mb-2">
                      <h4 className="mt-2 mb-0">Modelos</h4>
                      <p>
                        Selecione um modelo de capa do comunicado de acordo com
                        o tema
                      </p>
                      <div className="search-bar mb-1">
                        <input
                          type="search"
                          onChange={this.handleSearch}
                          value={search}
                          className="form-control"
                          placeholder="Pesquisar modelos..."
                        />
                        {search && search.length > 0 && (
                          <button
                            className="button-clear"
                            type="button"
                            onClick={this.clearSearch}
                          >
                            <FiX />
                          </button>
                        )}
                      </div>
                      <div className="tags">
                        {tags.map((item, index) => (
                          <button
                            key={item}
                            className={`btn btn-sm btn-${
                              tagSelected === item ? 'info' : 'secondary'
                            } p-1 mr-2`}
                            type="button"
                            onClick={() => this.onFilterTag(item)}
                          >
                            {item}
                          </button>
                        ))}
                      </div>
                    </header>
                    <section>
                      {covers.length > 0 &&
                        covers.map(item => (
                          <button
                            key={item.image}
                            style={{ padding: 0 }}
                            className={`card text-dark mb-2
                        ${!item.visible && 'd-none'}
                         ${coverSelected &&
                           coverSelected.image === item.image &&
                           'active'}`}
                            onClick={() => this.selectCover(item)}
                            type="button"
                          >
                            <img
                              src={item.image}
                              className="card-img-top border-bottom"
                              alt="Capa selecionada"
                            />
                          </button>
                        ))}
                      {covers.length <= 0 && (
                        <div className="card-no-result text-center p-4">
                          Nenhum modelo encontrado para{' '}
                          <strong>{search}</strong>
                          <br />
                          <strong style={{ fontSize: '3rem' }}>:(</strong>
                        </div>
                      )}
                    </section>
                  </aside>
                </ThumbList>
                <WrapperCanva isEditing={coverSelected}>
                  {!coverSelected && (
                    <NoCoverMessage>
                      <h2>
                        Selecione um modelo para começar a criar um comunicado
                      </h2>
                      <FiFileText />
                    </NoCoverMessage>
                  )}
                  {coverSelected && (
                    <Canva id="canva" isSaving={isSaving}>
                      <div className="header">
                        {coverSelected.haveHeader && (
                          <div className="h3" id="header-editor" />
                        )}
                        <img src={coverSelected.image} alt="Capa selecionada" />
                      </div>
                      <section>
                        <div id="toolbar" />
                        <div id="editor" />
                      </section>
                      <footer>
                        <img
                          src={coverSelected.footer}
                          alt="Rodapé do modelo"
                        />
                      </footer>
                    </Canva>
                  )}
                </WrapperCanva>
                <WrapperAction>
                  <section className="action">
                    <div className="card">
                      <div className="card-body">
                        <h5 className="card-title">Comunicado</h5>
                        <p className="card-text">
                          1. Escolha um modelo
                          <br />
                          2. Edite o texto
                          <br />
                          3. Clique em Salvar!
                        </p>
                        <button
                          className={`card-link btn btn-${
                            !coverSelected ? 'secondary' : 'primary'
                          }`}
                          disabled={!coverSelected || isSaving}
                          onClick={() => saveImage('#canva')}
                          type="button"
                        >
                          {isSaving ? 'Salvando...' : 'Salvar'}
                        </button>
                      </div>
                    </div>
                  </section>
                </WrapperAction>
              </div>
            </div>
          </>
        )}
      </Printer>
    );
  }
}
